export const ERROR_CODES = {
  MISSING_PAYMENT_TYPE: '409001',
}

export const ERROR_CODE_MAPPINGS = {
  [ERROR_CODES.MISSING_PAYMENT_TYPE]: 'Missing primary contact',
}
